import {HOSTNAME} from "../constants";

/**
 * Where the signed-in routes live depends on which host served the bundle.
 *
 * On the app subdomain `index.tsx` mounts `appRouter`, which serves the
 * signed-in pages from the root (`/practice`). Everywhere else — the test host
 * and local dev — it mounts `devRouter`, which nests the same pages under
 * `/app` (`/app/practice`) so the guest site can share the origin.
 *
 * That split used to be re-derived at sixteen call sites, and the paths were
 * written out by hand, so a link like `/app/practice` silently pointed at
 * nothing once production moved to the subdomain. Resolve paths through
 * `appRoute` instead of hardcoding either shape.
 */
export const productionMode = window.location.hostname.endsWith(HOSTNAME) && !window.location.hostname.startsWith("test")

/** True on the app subdomain, which is what selects `appRouter`. */
export const appHost = window.location.hostname.startsWith("app")

/**
 * The prefix the signed-in routes carry here: "" in production, "/app" on the
 * test and dev hosts. Useful for matching `location.pathname`; to build a link,
 * prefer `appRoute`.
 */
export const APP_PREFIX = productionMode ? "" : "/app"

/**
 * Resolve a signed-in route for the current host.
 *
 * Leading slashes on `path` are optional. Called with no argument it returns
 * the signed-in landing page ("/" in production, "/app" otherwise).
 */
/**
 * Resolve a public (guest site) page for the current host. The app subdomain only serves the
 * signed-in pages, so there public pages like /pricing live on the main domain; on the test and
 * dev hosts the same bundle serves both, and a relative path works.
 */
export const guestRoute = (path: string) =>
    appHost ? `https://${HOSTNAME}${path.startsWith("/") ? path : `/${path}`}` : path

export const appRoute = (path = "") => {
    const suffix = path.replace(/^\/+/, "")

    if (!suffix)
        return APP_PREFIX || "/"

    return `${APP_PREFIX}/${suffix}`
}
